(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(1382);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/components/lib/index.js
var lib = __webpack_require__(34906);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.gen.tsx
var Button_gen = __webpack_require__(2770);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RichText/RichText.gen.tsx
var RichText_gen = __webpack_require__(6555);
// EXTERNAL MODULE: ./node_modules/@prezzee/tokens/lib/index.js
var tokens_lib = __webpack_require__(53126);
;// CONCATENATED MODULE: ./src/api/graphql/modules/TextChunkBlock/resolvers.ts
var supportingAsset = function(asset) {
    if (!asset) return null;
    return {
        src: asset.__typename === "Icon" ? asset.svg.url : asset.file.url,
        alt: asset.__typename === "Icon" ? asset.svg.description : asset.file.description,
        width: asset.__typename === "Icon" ? asset.svg.width : asset.file.height,
        height: asset.__typename === "Icon" ? asset.svg.width : asset.file.height
    };
};


// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/utils/SegmentUtils.bs.js
var SegmentUtils_bs = __webpack_require__(25235);
;// CONCATENATED MODULE: ./src/components/pages/contact/Card.tsx



var style = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;box-shadow:", tokens_lib.shadows.md, ";border-radius:", tokens_lib.spacing.spacing01, ";padding:", tokens_lib.spacing.spacing08, ";background-color:", tokens_lib.colors.white, ";height:100%;img{height:28px;width:28px;margin-bottom:12px;}h3{font-size:24px;color:", tokens_lib.colors.gray800, ";font-weight:600;margin-bottom:12px;}");
var Card = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: style,
        children: children
    });
};
/* harmony default export */ var contact_Card = (Card);

// EXTERNAL MODULE: ./src/components/CmsImage.tsx
var CmsImage = __webpack_require__(73450);
// EXTERNAL MODULE: ./src/hooks/useSmartLink.tsx
var useSmartLink = __webpack_require__(12427);
;// CONCATENATED MODULE: ./src/components/pages/contact/CardGrid.tsx

















var verticalMargin = 30;
var CardGrid_style = {
    col: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:", verticalMargin, "px;"),
    row: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:calc(-30px + -", verticalMargin, "px);margin-bottom:50px;"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-bottom:", tokens_lib.spacing.spacing04, ";color:", tokens_lib.colors.gray600, ";"),
    cta: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("align-self:flex-start;margin-top:auto;")
};
var CardContainer = function(param) {
    var card = param.card;
    var title = card.title, callToActionText = card.callToActionText, chunkBlockOfText = card.chunkBlockOfText, link = card.link, _system_ = card._system_;
    var asPath = (0,router.useRouter)().asPath;
    var spotlightProps = (0,useSmartLink/* default */.Z)(_system_);
    var image = supportingAsset(card.supportingAsset);
    var openInNewWindow = card.openInNewWindow.items.length ? card.openInNewWindow.items[0]._system_.codename === "yes" ? true : false : false;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        lg: 4,
        className: CardGrid_style.col
    }, spotlightProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(contact_Card, {
            children: [
                image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                    sizes: "28px"
                })),
                title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                    children: title
                }),
                chunkBlockOfText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                    className: CardGrid_style.description,
                    children: chunkBlockOfText.html
                }),
                link && callToActionText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var props;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    props = {
                                        element: SegmentUtils_bs/* SegmentUtils.mapElement */.I.mapElement(callToActionText),
                                        path: asPath
                                    };
                                    return [
                                        4,
                                        Segment_bs/* customElementInteractionAsync */.GS((0,_object_spread/* default */.Z)({}, props))
                                    ];
                                case 1:
                                    _state.sent();
                                    window.open(link, openInNewWindow ? "_blank" : "_self");
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    className: CardGrid_style.cta,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_gen/* make */.S, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                            children: callToActionText
                        })
                    })
                })
            ]
        })
    }));
};
var CardGrid = function(param) {
    var block = param.block;
    var spotlightProps = (0,useSmartLink/* default */.Z)(block._system_);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        wrap: "wrap",
        className: CardGrid_style.row
    }, spotlightProps), {
        children: block.addressedNeeds.items.map(function(card, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CardContainer, {
                card: card
            }, index);
        })
    }));
};
/* harmony default export */ var contact_CardGrid = (CardGrid);

// EXTERNAL MODULE: ./src/css/theme.ts
var theme = __webpack_require__(55374);
// EXTERNAL MODULE: ./src/common/utils/react.tsx
var react = __webpack_require__(4331);
// EXTERNAL MODULE: ./src/common/utils/string.ts
var string = __webpack_require__(53782);
;// CONCATENATED MODULE: ./src/components/pages/contact/Tag.tsx






var linkType = {
    email: "mailto:",
    phone: "tel:",
    website: string/* EMPTY_STRING */.v6
};
var Styles = {
    tagContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;background-color:", theme/* Color.Lilac50 */.Il.Lilac50, ";width:fit-content;padding:0.6rem;margin-right:0.5rem;border-radius:4px;align-items:center;justify-content:center;margin-top:0.5rem;"),
    icon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:21px;"),
    text: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", theme/* Color.Gray800 */.Il.Gray800, ";margin-left:0.7rem;margin-bottom:0.2rem;"),
    link: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex-shrink:none;")
};
var Tag = function(param) {
    var children = param.children, icon = param.icon, type = param.type, href = param.href, onClick = param.onClick;
    var description = (icon === null || icon === void 0 ? void 0 : icon.description) || "icon";
    var url = (icon === null || icon === void 0 ? void 0 : icon.url) || "";
    var link = "".concat(type).concat(href ? href : children);
    var tagComponent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: Styles.tagContainer,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                src: url,
                alt: description,
                width: 21,
                height: 21,
                className: Styles.icon
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: Styles.text,
                children: children
            })
        ]
    });
    if (!children && !icon) {
        return react/* EMPTY_ELEMENT */.O;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
        className: Styles.link,
        href: link,
        onClick: onClick,
        children: tagComponent
    });
};
/* harmony default export */ var contact_Tag = (Tag);

// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
;// CONCATENATED MODULE: ./src/components/pages/contact/ContactPhoneEmail.tsx











var ContactPhoneEmail_Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;padding-bottom:0.5rem;background-color:", theme/* Color.White */.Il.White, ";"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:1.375rem;font-weight:bold;color:", theme/* Color.Gray800 */.Il.Gray800, ";margin-bottom:1.7rem;"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:1.125rem;color:", theme/* Color.Gray600 */.Il.Gray600, ";margin-bottom:0.7rem;@media (max-width:576px){margin-bottom:0.4rem;}"),
    additionalDescription: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:1.125rem;color:", theme/* Color.Gray600 */.Il.Gray600, ";margin-top:1.3rem;@media (max-width:576px){margin-top:0.8rem;}"),
    phoneEmailTagContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;margin-bottom:0.7rem;flex-wrap:wrap;@media (max-width:576px){flex-direction:column;margin-bottom:0.4rem;}"),
    internationalCallText: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:1.2rem;font-weight:bold;color:", theme/* Color.Gray800 */.Il.Gray800, ";margin-bottom:0.5rem;")
};
var ContactPhoneEmail = function(param) {
    var contactData = param.contactData;
    var title = contactData.title, text = contactData.text, phoneContactMethodIconAsset = contactData.phoneContactMethodIconAsset, formContactMethodUrl = contactData.formContactMethodUrl, formContactMethodIconAsset = contactData.formContactMethodIconAsset, formContactMethodLabel = contactData.formContactMethodLabel, localPhoneNumber = contactData.localPhoneNumber, internationalPhoneNumber = contactData.internationalPhoneNumber, internationalPhoneNumberText = contactData.internationalPhoneNumberText, additionalContactMethodIconAsset = contactData.additionalContactMethodIconAsset, additionalContactMethodCopy = contactData.additionalContactMethodCopy, additionalContactMethodUrl = contactData.additionalContactMethodUrl, additionalContactMethodLabel = contactData.additionalContactMethodLabel, _system_ = contactData._system_;
    var asPath = (0,router.useRouter)().asPath;
    var ref = (0,useSegment/* default */.Z)(), customElementInteraction = ref.customElementInteraction, customElementInteractionAsync = ref.customElementInteractionAsync;
    var spotlightProps = (0,useSmartLink/* default */.Z)(_system_);
    var isAdditionalContactMethod = additionalContactMethodLabel !== "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: ContactPhoneEmail_Styles.container
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                className: ContactPhoneEmail_Styles.title,
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                className: ContactPhoneEmail_Styles.description,
                children: text.html
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: ContactPhoneEmail_Styles.phoneEmailTagContainer,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_Tag, {
                        href: formContactMethodUrl,
                        icon: formContactMethodIconAsset,
                        type: linkType.website,
                        onClick: function(e) {
                            e.preventDefault();
                            customElementInteractionAsync({
                                element: SegmentUtils_bs/* SegmentUtils.mapElement */.I.mapElement(formContactMethodLabel),
                                path: asPath
                            }).finally(function() {
                                return window.open(formContactMethodUrl, "_self");
                            });
                        },
                        children: formContactMethodLabel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_Tag, {
                        onClick: function() {
                            customElementInteraction({
                                element: "call_national",
                                path: asPath
                            });
                        },
                        icon: phoneContactMethodIconAsset,
                        type: linkType.phone,
                        children: localPhoneNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                className: ContactPhoneEmail_Styles.internationalCallText,
                children: internationalPhoneNumberText
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_Tag, {
                onClick: function() {
                    customElementInteraction({
                        element: "call_international",
                        path: asPath
                    });
                },
                icon: phoneContactMethodIconAsset,
                type: linkType.phone,
                children: internationalPhoneNumber
            }),
            isAdditionalContactMethod ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                        className: ContactPhoneEmail_Styles.additionalDescription,
                        children: additionalContactMethodCopy.html
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_Tag, {
                        icon: additionalContactMethodIconAsset,
                        onClick: function(e) {
                            e.preventDefault();
                            customElementInteractionAsync({
                                element: "lodge_a_complaint_cta",
                                path: asPath
                            }).finally(function() {
                                return window.open(additionalContactMethodUrl, "_self");
                            });
                        },
                        type: linkType.website,
                        href: additionalContactMethodUrl,
                        children: additionalContactMethodLabel
                    })
                ]
            }) : null
        ]
    }));
};
/* harmony default export */ var contact_ContactPhoneEmail = (ContactPhoneEmail);

// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./src/components/pages/contact/ContactStyles.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1440)),
    tl: {
        hd: BsCss_bs/* marginLeft */.oIA("auto"),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR("auto"),
            tl: {
                hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs.px(30)),
                tl: {
                    hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs.px(30)),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var rootContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
    tl: /* [] */ 0
});
var bottomContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.lilac300 */.Il.lilac300),
    tl: {
        hd: BsCss_bs/* padding2 */.BLt(BsCss_bs.px(40), "zero"),
        tl: /* [] */ 0
    }
});
var bottomContainerSection = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* important */.efO(BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1440))),
    tl: {
        hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
            hd: BsCss_bs/* important */.efO(BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(1.25))),
            tl: {
                hd: BsCss_bs/* important */.efO(BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(1.25))),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmOrTablet */.Ku, {
                hd: BsCss_bs/* important */.efO(BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(2))),
                tl: {
                    hd: BsCss_bs/* important */.efO(BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(2))),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var bottomInnerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* padding2 */.BLt(BsCss_bs/* rem */.hOB(1.5), BsCss_bs/* rem */.hOB(1)),
    tl: {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
        tl: {
            hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(4)),
            tl: {
                hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(6), BsCss_bs.px(12), undefined, undefined, BsCss_bs/* rgba */.m4f(0, 0, 0, BsCss_bs/* pct */.hdZ(11.0)))),
                tl: {
                    hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
                        hd: BsCss_bs/* padding */.o3D(BsCss_bs/* rem */.hOB(2.625)),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                            hd: BsCss_bs/* display */.jfB("flex"),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: BsCss_bs/* selector */.nZE("&>*:not(:first-child)", {
                                hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletOrMobile */.k$, {
                                    hd: BsCss_bs/* borderTop */.j1L(BsCss_bs.px(1), "solid", Theme_bs/* Color.gray300 */.Il.gray300),
                                    tl: /* [] */ 0
                                }),
                                tl: {
                                    hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                                        hd: BsCss_bs/* borderLeft */.sc3(BsCss_bs.px(1), "solid", Theme_bs/* Color.gray300 */.Il.gray300),
                                        tl: /* [] */ 0
                                    }),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var ContactStyles_bs_Styles = {
    container: container,
    rootContainer: rootContainer,
    bottomContainer: bottomContainer,
    bottomContainerSection: bottomContainerSection,
    bottomInnerContainer: bottomInnerContainer
};
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./src/bindings/Media.js
var Media = __webpack_require__(86265);
;// CONCATENATED MODULE: ./src/components/pages/contact/CustomerCareBanner.tsx









var CustomerCareBanner_Styles = {
    container: function(backgroundColor) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:", backgroundColor, ";display:flex;flex-direction:row;justify-content:end;@media (max-width:599px){flex-direction:column;}");
    },
    textContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;width:50%;align-items:center;justify-content:center;margin-left:8%;max-width:700px;margin-left:2rem;div{width:100%;}@media (max-width:640px){margin-top:3rem;margin-bottom:3rem;}@media (max-width:599px){width:90%;margin:2rem auto;}"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-family:DM Serif Display;font-style:italic;font-size:4rem;line-height:4.5rem;width:100%;color:", theme/* Color.Purple500 */.Il.Purple500, ";@media (max-width:1288px){font-size:3rem;line-height:3.5rem;margin-bottom:0.5rem;}"),
    text: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", theme/* Color.Gray800 */.Il.Gray800, ";margin-top:0.5rem;@media (max-width:1024px){margin:0;}@media (max-width:599px){margin-top:0;margin-bottom:3rem;}"),
    imageContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;justify-content:end;width:50%;div{width:100%;max-width:800px;}@media (max-width:599px){width:100%;}@media (min-width:600px) and (max-width:611px){width:60%;}"),
    image: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;@media (max-width:640px){height:100%;}")
};
var CCBanner = function(param) {
    var bannerData = param.bannerData;
    var title = bannerData.title, text = bannerData.text, backgroundColour = bannerData.backgroundColour, bannerAssetDesktop = bannerData.bannerAssetDesktop, bannerAssetTablet = bannerData.bannerAssetTablet, bannerAssetMobile = bannerData.bannerAssetMobile, _system_ = bannerData._system_;
    var spotlightProps = (0,useSmartLink/* default */.Z)(_system_);
    var mobile = "(max-width: 599px)";
    var desktopLg = "(max-width: 1600px)";
    var createBannerImage = function(imageObject, sizes) {
        var file = imageObject;
        if (!file) return;
        var description = (file === null || file === void 0 ? void 0 : file.description) || "bannerImage";
        var url = (file === null || file === void 0 ? void 0 : file.url) || "";
        var width = (file === null || file === void 0 ? void 0 : file.width) || 0;
        var height = (file === null || file === void 0 ? void 0 : file.height) || 0;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
            src: url,
            alt: description,
            width: width,
            height: height,
            className: CustomerCareBanner_Styles.image,
            sizes: sizes
        });
    };
    var tabletDesktopBannerImage = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Media/* Media */.pU, {
                between: [
                    "mobile",
                    "lg"
                ],
                children: createBannerImage(bannerAssetTablet, "50vw")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Media/* Media */.pU, {
                greaterThanOrEqual: "lg",
                children: createBannerImage(bannerAssetDesktop, "".concat(desktopLg, " 50vw, 800px"))
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: CustomerCareBanner_Styles.container(backgroundColour)
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Media/* Media */.pU, {
                    lessThan: "mobile",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: CustomerCareBanner_Styles.imageContainer,
                        children: createBannerImage(bannerAssetMobile, "100vw")
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: CustomerCareBanner_Styles.textContainer,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
                        className: CustomerCareBanner_Styles.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                        className: CustomerCareBanner_Styles.text,
                        children: text.html
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: CustomerCareBanner_Styles.imageContainer,
                children: tabletDesktopBannerImage
            })
        ]
    }));
};
/* harmony default export */ var CustomerCareBanner = (CCBanner);

;// CONCATENATED MODULE: ./src/components/pages/contact/CustomerCareEnquiries.tsx












var CustomerCareEnquiries_Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;padding-bottom:1.5rem;"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:1.5rem;line-height:2rem;color:", theme/* Color.Gray800 */.Il.Gray800, ";font-weight:bold;margin-bottom:1rem;")
};
var BoxStyles = {
    boxContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;@media (max-width:1024px){flex-direction:column;}flex-wrap:wrap;"),
    box: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:3rem 1.25rem;border:1px solid ", theme/* Color.Gray200 */.Il.Gray200, ";border-radius:4px;width:32%;margin-bottom:1rem;@media (max-width:600px){padding:2rem 1.25rem;}@media (max-width:1024px){width:100%;padding:2.5rem 1.25rem;margin-right:0;};"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-weight:bold;color:", theme/* Color.Purple400 */.Il.Purple400, ";font-size:1rem;line-height:1.5rem;width:100%;"),
    arrowIcon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-left:1rem;width:1.5rem;")
};
var EnquiryBox = function(param) {
    var card = param.card;
    var title = card.title, link = card.link, supportingAsset = card.supportingAsset, _system_ = card._system_;
    var spotlightProps = (0,useSmartLink/* default */.Z)(_system_);
    var asPath = (0,router.useRouter)().asPath;
    var imageUrl = supportingAsset.__typename === "Image" ? supportingAsset.file.url : "/images/about/arrow-right.svg";
    var imageWidth = supportingAsset.__typename === "Image" ? supportingAsset.file.width : supportingAsset.svg.width;
    var imageHeight = supportingAsset.__typename === "Image" ? supportingAsset.file.height : supportingAsset.svg.height;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var props;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        props = {
                            element: SegmentUtils_bs/* SegmentUtils.mapElement */.I.mapElement(title),
                            path: asPath
                        };
                        return [
                            4,
                            Segment_bs/* customElementInteractionAsync */.GS((0,_object_spread/* default */.Z)({}, props))
                        ];
                    case 1:
                        _state.sent();
                        window.open(link, "_self");
                        return [
                            2
                        ];
                }
            });
        }),
        className: BoxStyles.box
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                className: BoxStyles.title,
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                className: BoxStyles.arrowIcon,
                src: imageUrl,
                alt: "icon",
                width: imageWidth || 0,
                height: imageHeight || 0,
                sizes: "22px"
            })
        ]
    }));
};
var CustomerCareEnquiries = function(param) {
    var block = param.block;
    var ref;
    var spotlightProps = (0,useSmartLink/* default */.Z)(block._system_);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: CustomerCareEnquiries_Styles.container
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                className: CustomerCareEnquiries_Styles.title,
                children: ((ref = block.areaHeader) === null || ref === void 0 ? void 0 : ref.title) || "Top Enquiries"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: BoxStyles.boxContainer,
                children: block.addressedNeeds.items.map(function(card, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnquiryBox, {
                        card: card
                    }, index);
                })
            })
        ]
    }));
};
/* harmony default export */ var contact_CustomerCareEnquiries = (CustomerCareEnquiries);

// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
;// CONCATENATED MODULE: ./src/pages/contact.tsx

__webpack_require__(14473);






var compMap = function(component, index) {
    switch(component.__typename){
        case "CustomerCareBanner":
            return [
                "banner",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CustomerCareBanner, {
                    bannerData: component
                }, index)
            ];
        case "CustomerCareCallUs":
            return [
                "callUs",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_ContactPhoneEmail, {
                    contactData: component
                }, index)
            ];
        case "AreaOfInterest":
            switch(component.importance.items[0]._system_.codename){
                case "high":
                    return [
                        "areaOfInterestHigh",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_CardGrid, {
                            block: component
                        }, index)
                    ];
                case "medium":
                    return [
                        "areaOfInterestMedium",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contact_CustomerCareEnquiries, {
                            block: component
                        }, index)
                    ];
                default:
                    return null;
            }
        default:
            return null;
    }
};
var Contact = function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    var components = ((ref = data === null || data === void 0 ? void 0 : data.items[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.pageLayout) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.linkedItems) === null || ref2 === void 0 ? void 0 : ref2.items) || [];
    var componentMap = components.map(function(component, index) {
        return compMap(component, index);
    });
    var getComponentByName = function(name) {
        return componentMap.map(function(component) {
            if (component && component[0] === name) return component[1];
        });
    };
    var hasCallUsComponent = getComponentByName("callUs").some(function(v) {
        return !!v;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: ContactStyles_bs_Styles.rootContainer,
        children: [
            getComponentByName("banner"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: ContactStyles_bs_Styles.container,
                children: [
                    getComponentByName("areaOfInterestHigh"),
                    getComponentByName("areaOfInterestMedium")
                ]
            }),
            hasCallUsComponent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: ContactStyles_bs_Styles.bottomContainer,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: [
                        IndexStyles_bs/* section */.qi,
                        ContactStyles_bs_Styles.bottomContainerSection
                    ].join(" "),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: ContactStyles_bs_Styles.bottomInnerContainer,
                        children: getComponentByName("callUs")
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var contact = (Contact);


/***/ }),

/***/ 2770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _Button_bs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10573);
/* TypeScript file generated from Button.res by genType. */ /* eslint-disable import/first */ var $$toRE77295138 = {
    "Nothing": 0,
    "Normal": 1
};
var $$toRE124709062 = {
    "Regular": 0,
    "Small": 1,
    "Icon": 2
};
var $$toRE256299128 = {
    "Contained": 0,
    "Outlined": 1,
    "None": 2
};
var $$toRE354646326 = {
    "Red": 0,
    "Charcoal": 1,
    "White": 2,
    "BusinessPurple": 3,
    "BusinessCharcoal": 4,
    "Primary": 5,
    "Secondary": 6,
    "Tertiary": 7
};
// @ts-ignore: Implicit any on import

var ButtonBS = _Button_bs__WEBPACK_IMPORTED_MODULE_0__;
var make = function make(Arg1) {
    var result = ButtonBS.make({
        children: Arg1.children,
        fill: Arg1.fill == null ? Arg1.fill : $$toRE256299128[Arg1.fill],
        colour: Arg1.colour == null ? Arg1.colour : typeof Arg1.colour === "object" ? {
            TAG: 0,
            _0: Arg1.colour[0],
            _1: Arg1.colour[1],
            _2: Arg1.colour[2]
        } : $$toRE354646326[Arg1.colour],
        variant: Arg1.variant == null ? Arg1.variant : $$toRE124709062[Arg1.variant],
        shadow: Arg1.shadow == null ? Arg1.shadow : $$toRE77295138[Arg1.shadow],
        className: Arg1.className
    });
    return result;
};


/***/ }),

/***/ 78078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE

function RichText(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        className: className$1,
        dangerouslySetInnerHTML: {
            __html: props.children
        }
    });
}
var make = RichText;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 6555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _RichText_bs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78078);
/* TypeScript file generated from RichText.res by genType. */ /* eslint-disable import/first */ // @ts-ignore: Implicit any on import

var RichTextBS = _RichText_bs__WEBPACK_IMPORTED_MODULE_0__;
var make = RichTextBS.make;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);